module.exports = __webpack_public_path__ + "static/img/u3.1e9ddc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u3.png
// module id = FE6C
// module chunks = 1